type SearchParamValue = string | number | boolean | undefined | SearchParams;

export type SearchParams = { [key: string]: SearchParamValue };

const isSearchParams = (value: unknown): value is SearchParams => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const parseSearchParamsToSearchQuery = (args: SearchParams = {}): SearchParams =>
  Object.entries(args).reduce<SearchParams>((acc, [key, value]) => {
    // Always keep searchString as a raw string,
    // so characters like '.' remain part of the search term.
    if (key === 'searchString' && typeof value === 'string') {
      acc[key] = value;
      return acc;
    }

    let normalized: SearchParamValue;

    if (isSearchParams(value)) {
      normalized = Object.values(value).join('').trim().length
        ? parseSearchParamsToSearchQuery(value)
        : undefined;
    } else if (typeof value === 'boolean') {
      normalized = value;
    } else if (typeof value === 'number') {
      normalized = value;
    } else if (typeof value === 'string') {
      const asNumber = Number(value);
      normalized = !Number.isNaN(asNumber) ? asNumber : value.length ? value : undefined;
    } else {
      normalized = undefined;
    }

    acc[key] = normalized;
    return acc;
  }, {});
